import React from 'react';
import { Provider } from "react-redux";
import store from "./store/store";
import './App.scss';
import MainLayoutContainer from "./containers/MainLayoutContainer";

function App() {
  return (
    <Provider store={store}>
      <MainLayoutContainer  />
    </Provider> 
    
  );
}
 
export default App;